import { AddButton } from '@rd-web-markets/shared/dist/util/buttons';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import BenefitAdjustmentsTable from './BenefitAdjustmentsTable';
export default function AdjustmentsRow(_ref) {
  let {
    claim,
    type,
    setLoading,
    adjustments,
    setAdjustments
  } = _ref;
  const sectionName = type === 'adduction' ? 'Add Back' : 'Deduct';
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 4
  }, sectionName), /*#__PURE__*/React.createElement(Col, {
    sm: 4
  }, /*#__PURE__*/React.createElement(AddButton, {
    text: 'Add Row',
    onClick: () => setAdjustments(adjustments => [...adjustments, {
      id: `new_${Math.floor(Math.random() * 1000) + 1}`,
      adjustment_type: type,
      amount: 0
    }])
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 4
  }, /*#__PURE__*/React.createElement(BenefitAdjustmentsTable, {
    claim: claim,
    type: type,
    setLoading: setLoading,
    adjustments: adjustments,
    setAdjustments: setAdjustments
  })));
}